import React, { useState } from "react";
import { Cookies } from "react-cookie";
import axiosClient from "utils/axios";

const CSRFContext = React.createContext({});

function CSRFProvider({ children }) {
  const c = new Cookies();
  let [csrfProvided, setCsrfProvided] = useState(!!c.get("csrftoken"));

  if (!csrfProvided) {
    (async () => {
      const data = await axiosClient.get("/csrf/");
      setCsrfProvided(!!c.get("csrftoken"));
    })();
  }

  axiosClient.defaults.headers.common["X-CSRFToken"] = c.get("csrftoken");

  return (
    <CSRFContext.Provider value={{}}>
      {csrfProvided && children}
    </CSRFContext.Provider>
  );
}

export { CSRFProvider, CSRFContext };
